module.exports = __webpack_public_path__ + "img/1529683636.e5aa479a.jpg";